<script>
import { RouterLink } from "vue-router";

import IconIrregular from "@/components/icons/green/IconGreenIrregular.vue";
import IconSettings from "@/components/icons/green/IconGreenSettings.vue";
import IconSpelling from "@/components/icons/green/IconGreenSpelling.vue";
import IconWorkshopDocument from "@/components/icons/green/IconGreenWorkshopDocument.vue";
import IconHelp from "@/components/icons/IconHelp.vue";
import IconInfo from "@/components/icons/IconInfo.vue";
import IconLogout from "@/components/icons/IconLogout.vue";
import IconChevronRight from "@/components/icons/white/IconWhiteChevronRight.vue";

export default {
  name: "NavbarItem",
  components: {
    IconChevronRight,
    IconHelp,
    IconInfo,
    IconIrregular,
    IconLogout,
    IconSettings,
    IconSpelling,
    IconWorkshopDocument,
    RouterLink
  },
  props: {
    tag: {
      type: String,
      default: "div"
    },
    item: {
      type: Object,
      required: true
    },
    block: {
      type: String,
      default: "navbar"
    },
    linkClass: {
      type: String,
      default: "navbar__link"
    },
    buttonClass: {
      type: String,
      default: "navbar__button"
    }
  },
  emits: ["click"],
  computed: {
    currentRoute() {
      return this.$router.currentRoute.value.name;
    }
  },
  methods: {
    onClick(item) {
      if (typeof item.click === "function") {
        item.click();
      }

      this.$emit("click");
    }
  }
};
</script>

<template>
  <Component :is="tag">
    <template v-if="item.type === 'button'">
      <button :class="buttonClass" @click.stop="item.action($event)">
        <slot name="icon-left" :icon="item.icon">
          <Component :is="item.icon" :class="`${block}__icon`" role="presentation" />
        </slot>
        <span :class="`${block}__item-text`">{{ item.title }}</span>
        <slot name="icon-right">
          <IconChevronRight :class="`${block}__chevron`" role="presentation" />
        </slot>
        <slot />
      </button>
    </template>
    <template v-if="item.type === 'link'">
      <RouterLink
        tabindex="0"
        :class="linkClass"
        :to="item.action()"
        :exact-active-class="`${block}__link--active`"
        @click="onClick(item)"
      >
        <slot name="icon-left" :icon="item.icon">
          <Component :is="item.icon" :class="`${block}__icon`" role="presentation" />
        </slot>
        <span :class="`${block}__item-text`">{{ item.title }}</span>
        <span v-if="currentRoute === item.action()" class="sr-only">{{
          $t("menu.isCurrentRoute")
        }}</span>
        <slot name="icon-right">
          <IconChevronRight :class="`${block}__chevron`" role="presentation" />
        </slot>
        <slot />
      </RouterLink>
    </template>
  </Component>
</template>
